var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 16H206.5V496H239.5V16Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 16H239.5V496H272.5V16Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.5 16H272.5V496H305.5V16Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 239.5V206.5H16V239.5H496Z",
    fill: "#F1C40F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 272.5V239.5H16V272.5H496Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496 305.5V272.5H16V305.5H496Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256 357.351C311.975 357.351 357.351 311.974 357.351 255.999C357.351 200.025 311.975 154.648 256 154.648C200.025 154.648 154.649 200.025 154.649 255.999C154.649 311.974 200.025 357.351 256 357.351Z",
    fill: "#D41C30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.75 175.993L256 166.723L258.953 175.844L268.851 175.993L261.02 181.973L264.568 192.142L256 185.864L247.581 191.844L250.831 181.973L243.149 176.142L252.75 175.993V175.993Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 1.23422
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M272.021 312.596C275.349 312.249 277.095 298.631 275.92 282.18C274.745 265.728 271.094 252.672 267.766 253.019C264.437 253.366 262.692 266.984 263.867 283.436C265.042 299.888 268.692 312.943 272.021 312.596Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.803353
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M277.981 312.53C281.501 312.164 283.397 298.531 282.215 282.08C281.033 265.629 277.221 252.589 273.701 252.955C270.18 253.321 268.285 266.954 269.466 283.405C270.648 299.857 274.46 312.896 277.981 312.53Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.826182
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M275.321 317.269C278.138 316.971 279.393 301.987 278.125 283.8C276.857 265.614 273.547 251.112 270.73 251.409C267.914 251.707 266.658 266.691 267.926 284.878C269.194 303.065 272.505 317.567 275.321 317.269Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.776972
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.126 298.273C231.3 298.058 229.054 295.289 231.666 293.816C234.278 292.345 237.994 293.319 239.109 295.158C240.224 296.998 239.33 298.805 240.765 298.829C242.202 298.854 281.257 297.216 282.664 298.758C284.072 300.299 284.305 303.337 282.846 304.518C281.387 305.714 232.012 306.266 230.311 305.016C228.611 303.784 226.121 298.577 226.126 298.273V298.273Z",
    fill: "#9C4A00",
    stroke: "black",
    strokeWidth: 0.81125
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.718 302.077C253.625 305.979 259.397 304.874 259.476 308.133C259.302 311.588 249.797 308.345 249.706 302.024C250.101 295.71 259.404 292.59 259.519 296.197C259.605 299.193 253.812 298.175 253.718 302.077Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.780765
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.124 302.122C257.03 306.024 262.802 304.919 262.882 308.178C262.708 311.633 253.203 308.389 253.112 302.069C253.507 295.755 262.81 292.635 262.925 296.241C263.011 299.238 257.218 298.22 257.124 302.122V302.122Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.780765
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.778 301.984C260.684 305.887 266.456 304.781 266.535 308.041C266.361 311.496 256.857 308.252 256.765 301.931C257.16 295.617 266.464 292.497 266.579 296.104C266.664 299.1 260.872 298.082 260.778 301.984Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.780765
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M264.184 302.029C264.09 305.932 269.862 304.826 269.941 308.085C269.767 311.541 260.262 308.297 260.171 301.976C260.566 295.662 269.869 292.542 269.984 296.149C270.07 299.145 264.277 298.127 264.184 302.029Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.780765
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280.359 304.877C282.179 304.904 283.685 303.429 283.724 301.582C283.763 299.735 282.319 298.216 280.5 298.188C278.68 298.161 277.173 299.636 277.134 301.483C277.096 303.33 278.539 304.849 280.359 304.877Z",
    fill: "#9C4A00",
    stroke: "black",
    strokeWidth: 0.697943
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M261.325 296.782C262.936 296.539 263.933 293.456 263.553 289.896C263.172 286.336 261.557 283.647 259.946 283.89C258.335 284.133 257.338 287.216 257.718 290.776C258.099 294.336 259.714 297.025 261.325 296.782Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.890863
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.354 296.39C257.965 296.147 258.963 293.064 258.582 289.504C258.201 285.944 256.586 283.255 254.975 283.498C253.364 283.741 252.367 286.824 252.748 290.385C253.129 293.945 254.743 296.634 256.354 296.39Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.890863
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M252.794 290.027C254.406 289.784 255.403 286.701 255.022 283.141C254.641 279.581 253.027 276.892 251.416 277.135C249.805 277.378 248.807 280.461 249.188 284.021C249.569 287.581 251.183 290.27 252.794 290.027Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.890862
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M257.899 290.416C259.448 290.171 260.366 286.789 259.948 282.861C259.531 278.934 257.937 275.948 256.388 276.193C254.839 276.438 253.922 279.821 254.339 283.748C254.756 287.676 256.35 290.661 257.899 290.416Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.917982
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M264.806 290.035C266.355 289.795 267.293 286.616 266.901 282.933C266.508 279.251 264.934 276.46 263.385 276.699C261.835 276.939 260.897 280.118 261.289 283.801C261.682 287.483 263.256 290.275 264.806 290.035Z",
    fill: "#006B3F",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260.986 287.733C262.536 287.494 263.474 284.314 263.081 280.632C262.689 276.949 261.114 274.158 259.565 274.397C258.015 274.637 257.077 277.816 257.47 281.499C257.862 285.182 259.437 287.973 260.986 287.733Z",
    fill: "#006B3F",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M256.166 284.413C257.716 284.173 258.654 280.994 258.261 277.311C257.869 273.629 256.295 270.838 254.745 271.077C253.196 271.317 252.258 274.496 252.65 278.179C253.043 281.861 254.617 284.652 256.166 284.413Z",
    fill: "#006B3F",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M251.704 282.4C253.253 282.161 254.191 278.981 253.799 275.299C253.406 271.616 251.832 268.825 250.282 269.064C248.733 269.304 247.795 272.483 248.187 276.166C248.58 279.849 250.154 282.64 251.704 282.4Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M246.045 220.401C246.045 220.401 236.142 228.995 237.253 252.255C238.5 275.647 259.141 286.643 259.141 286.643C259.141 286.643 264.402 280.003 263.791 261.208C262.316 233.73 252.569 221.589 252.569 221.589L246.045 220.401V220.401Z",
    fill: "#9461C9",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 297.551C269.505 297.599 271.035 294.743 271.295 291.172C271.555 287.601 270.446 284.667 268.817 284.619C267.188 284.571 265.658 287.427 265.398 290.998C265.138 294.569 266.247 297.503 267.876 297.551Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.890863
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M263.055 296.279C264.683 296.327 266.214 293.471 266.474 289.9C266.734 286.329 265.624 283.396 263.996 283.348C262.367 283.3 260.836 286.156 260.576 289.726C260.317 293.297 261.426 296.231 263.055 296.279Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.890863
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M260.686 289.384C262.315 289.432 263.846 286.577 264.105 283.006C264.365 279.435 263.256 276.501 261.627 276.453C259.998 276.405 258.468 279.261 258.208 282.832C257.948 286.403 259.058 289.336 260.686 289.384Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.890862
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M265.64 290.677C267.208 290.712 268.713 287.547 269.003 283.608C269.292 279.669 268.256 276.447 266.688 276.412C265.12 276.377 263.614 279.542 263.325 283.481C263.036 287.42 264.072 290.642 265.64 290.677Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.917982
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M272.504 291.533C274.071 291.573 275.561 288.612 275.831 284.918C276.101 281.225 275.049 278.198 273.482 278.157C271.915 278.117 270.425 281.078 270.155 284.772C269.885 288.465 270.936 291.492 272.504 291.533Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M269.155 288.587C270.723 288.627 272.212 285.666 272.482 281.972C272.753 278.279 271.701 275.251 270.133 275.211C268.566 275.171 267.076 278.132 266.806 281.826C266.536 285.519 267.588 288.546 269.155 288.587Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M265.005 284.461C266.572 284.501 268.062 281.54 268.332 277.846C268.602 274.153 267.55 271.125 265.983 271.085C264.415 271.045 262.926 274.006 262.656 277.7C262.385 281.393 263.437 284.42 265.005 284.461Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M260.972 281.685C262.539 281.726 264.029 278.764 264.299 275.071C264.569 271.377 263.517 268.35 261.95 268.31C260.382 268.269 258.893 271.231 258.623 274.924C258.353 278.618 259.404 281.645 260.972 281.685Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.888824
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M277.154 283.94C281.457 282.277 280.419 270.375 274.836 257.354C269.252 244.334 261.237 235.127 256.934 236.789C252.631 238.451 253.669 250.354 259.252 263.374C264.836 276.395 272.851 285.602 277.154 283.94Z",
    fill: "#D41C30",
    stroke: "black",
    strokeWidth: 0.256473
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M260.561 239.482C262.573 239.517 264.23 238.106 264.262 236.329C264.294 234.553 262.688 233.083 260.676 233.047C258.663 233.011 257.006 234.423 256.974 236.2C256.943 237.976 258.549 239.446 260.561 239.482Z",
    fill: "#006B3F",
    stroke: "black",
    strokeWidth: 0.7746
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M263.3 234.933C265.103 234.965 266.59 233.551 266.622 231.774C266.653 229.997 265.217 228.531 263.415 228.499C261.612 228.466 260.125 229.881 260.093 231.658C260.061 233.434 261.497 234.901 263.3 234.933Z",
    fill: "#006B3F",
    stroke: "black",
    strokeWidth: 0.774576
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M258.897 234.855C260.7 234.887 262.187 233.472 262.218 231.696C262.25 229.919 260.814 228.453 259.011 228.42C257.209 228.388 255.721 229.803 255.69 231.579C255.658 233.356 257.094 234.823 258.897 234.855Z",
    fill: "#006B3F",
    stroke: "black",
    strokeWidth: 0.774576
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M259.871 231.326C261.758 231.359 263.311 230.034 263.341 228.366C263.371 226.698 261.865 225.319 259.979 225.285C258.092 225.252 256.538 226.577 256.509 228.245C256.479 229.913 257.984 231.292 259.871 231.326Z",
    fill: "#006B3F",
    stroke: "black",
    strokeWidth: 0.774597
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M259.483 227.509C261.37 227.543 262.923 226.218 262.953 224.55C262.983 222.882 261.478 221.503 259.591 221.469C257.704 221.435 256.151 222.76 256.121 224.428C256.091 226.096 257.597 227.476 259.483 227.509Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774597
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M254.69 232.284C256.493 232.317 257.98 230.902 258.012 229.125C258.043 227.349 256.607 225.882 254.805 225.85C253.002 225.818 251.515 227.232 251.483 229.009C251.451 230.786 252.887 232.252 254.69 232.284Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774576
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M255.676 228.098C257.479 228.131 258.965 226.746 258.996 225.005C259.027 223.265 257.591 221.828 255.788 221.795C253.985 221.763 252.499 223.148 252.468 224.889C252.437 226.629 253.873 228.066 255.676 228.098Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774614
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M250.281 228.265C252.293 228.301 253.95 226.889 253.982 225.113C254.014 223.336 252.408 221.866 250.396 221.831C248.383 221.795 246.726 223.206 246.694 224.983C246.663 226.76 248.269 228.229 250.281 228.265Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.7746
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M256.986 222.736C258.873 222.77 260.426 221.445 260.456 219.777C260.486 218.109 258.98 216.729 257.094 216.696C255.207 216.662 253.654 217.987 253.624 219.655C253.594 221.323 255.1 222.702 256.986 222.736Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774597
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M252.417 223.443C254.22 223.475 255.707 222.09 255.738 220.35C255.769 218.609 254.332 217.172 252.53 217.14C250.727 217.108 249.24 218.493 249.209 220.234C249.178 221.974 250.615 223.411 252.417 223.443Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774614
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M245.494 228.443C247.297 228.475 248.784 227.06 248.815 225.284C248.847 223.507 247.411 222.04 245.608 222.008C243.806 221.976 242.319 223.391 242.287 225.167C242.255 226.944 243.691 228.411 245.494 228.443Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774576
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M246.63 225.976C248.433 226.008 249.919 224.623 249.95 222.883C249.981 221.142 248.545 219.705 246.742 219.673C244.939 219.641 243.453 221.026 243.422 222.767C243.391 224.507 244.827 225.944 246.63 225.976Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774614
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M248.015 223.325C249.818 223.357 251.304 221.972 251.335 220.232C251.366 218.491 249.93 217.054 248.127 217.022C246.324 216.99 244.838 218.375 244.807 220.115C244.776 221.856 246.212 223.293 248.015 223.325Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.774614
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M281.541 284.44C287.06 282.491 286.133 268.344 279.47 252.841C272.807 237.338 262.931 226.351 257.412 228.299C251.893 230.248 252.82 244.395 259.483 259.897C266.146 275.4 276.022 286.388 281.541 284.44Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.710322
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M280.801 267.116C281.824 266.63 281.484 263.62 280.042 260.393C278.601 257.166 276.603 254.944 275.58 255.431C274.557 255.917 274.897 258.927 276.339 262.154C277.781 265.381 279.779 267.602 280.801 267.116Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.709623
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M277.259 261.269C285.914 271.808 284.821 278.501 283.919 284.163C281.199 277.634 279.715 273.524 271.057 262.983C262.4 252.442 266.721 245.045 267.316 241.147C268.617 244.521 268.601 250.728 277.259 261.269V261.269Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M278.038 269.782C286.694 280.321 285.601 287.014 284.698 292.676C281.979 286.147 280.494 282.036 271.837 271.495C263.179 260.954 267.5 253.558 268.095 249.66C269.397 253.034 269.381 259.24 278.038 269.782V269.782Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M278.298 276.638C287.163 286.991 286.204 293.705 285.415 299.385C282.566 292.915 280.999 288.838 272.132 278.483C263.266 268.128 267.439 260.642 267.955 256.732C269.324 260.078 269.432 266.283 278.298 276.638Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M276.75 261.746C278.778 261.23 278.361 256.151 275.819 250.401C273.278 244.652 269.574 240.409 267.547 240.925C265.52 241.441 265.936 246.52 268.478 252.27C271.019 258.019 274.723 262.262 276.75 261.746Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.714483
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.29 265.807C274.114 265.493 273.99 261.38 272.015 256.621C270.039 251.861 266.959 248.257 265.135 248.571C263.311 248.884 263.434 252.997 265.41 257.757C267.386 262.516 270.466 266.121 272.29 265.807Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.718467
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M268.007 269.859C269.837 269.584 269.8 265.469 267.923 260.669C266.047 255.869 263.042 252.201 261.212 252.476C259.382 252.751 259.42 256.865 261.296 261.665C263.173 266.465 266.177 270.134 268.007 269.859Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.718498
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M271.081 253.19C272.555 252.92 272.374 249.824 270.677 246.276C268.979 242.728 266.408 240.07 264.933 240.34C263.459 240.61 263.64 243.706 265.338 247.254C267.035 250.802 269.607 253.46 271.081 253.19Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.722248
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M267.197 256.012C268.686 255.823 268.698 252.724 267.224 249.09C265.751 245.455 263.349 242.662 261.86 242.851C260.371 243.04 260.359 246.14 261.833 249.774C263.307 253.408 265.708 256.201 267.197 256.012Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.721659
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M261.824 245.346C264.383 251.599 265.419 257.222 264.135 257.898C262.852 258.573 259.734 254.046 257.175 247.793",
    fill: "#27AE60"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M261.824 245.346C264.383 251.599 265.419 257.222 264.135 257.898C262.852 258.573 259.734 254.046 257.175 247.793",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M266.776 248.667C268.265 248.478 268.277 245.378 266.803 241.744C265.329 238.11 262.928 235.317 261.439 235.506C259.95 235.695 259.938 238.794 261.411 242.428C262.885 246.062 265.287 248.856 266.776 248.667Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.721659
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M262.343 250.78C263.836 250.62 263.918 247.522 262.526 243.86C261.134 240.198 258.795 237.358 257.302 237.518C255.809 237.677 255.727 240.775 257.119 244.438C258.511 248.1 260.85 250.939 262.343 250.78Z",
    fill: "#27AE60",
    stroke: "black",
    strokeWidth: 0.721441
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M257.369 236.853C259.854 241.078 261.192 245.024 260.354 245.661C259.518 246.298 256.822 243.386 254.337 239.16",
    fill: "#27AE60"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M257.369 236.853C259.854 241.078 261.192 245.024 260.354 245.661C259.518 246.298 256.822 243.386 254.337 239.16",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M259.09 234.05C261.575 238.275 262.913 242.221 262.075 242.859C261.238 243.495 258.543 240.583 256.058 236.357",
    fill: "#27AE60"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M259.09 234.05C261.575 238.275 262.913 242.221 262.075 242.859C261.238 243.495 258.543 240.583 256.058 236.357",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M266.82 234.644C270.283 240.416 272.146 245.806 270.977 246.678C269.81 247.548 266.053 243.571 262.591 237.799",
    fill: "#27AE60"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M266.82 234.644C270.283 240.416 272.146 245.806 270.977 246.678C269.81 247.548 266.053 243.571 262.591 237.799",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M261.711 231.62C264.206 236.285 265.553 240.639 264.717 241.34C263.882 242.04 261.18 238.822 258.685 234.156",
    fill: "#27AE60"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M261.711 231.62C264.206 236.285 265.553 240.639 264.717 241.34C263.882 242.04 261.18 238.822 258.685 234.156",
    stroke: "black",
    strokeWidth: 0.709551
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M261.49 224.86C259.824 226.537 261.455 229.673 262.98 230.807C264.69 232.357 274.292 242.486 281.067 233.964C275.639 233.865 265.508 221.123 261.49 224.86Z",
    fill: "#9461C9",
    stroke: "black",
    strokeWidth: 0.728805
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M260.303 219.861C258.638 221.538 260.269 224.674 261.794 225.808C263.503 227.358 273.106 237.487 279.881 228.965C274.452 228.866 264.322 216.124 260.303 219.861Z",
    fill: "#9461C9",
    stroke: "black",
    strokeWidth: 0.728805
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M258.786 215.07C257.12 216.747 258.751 219.883 260.276 221.017C261.986 222.567 271.588 232.696 278.363 224.174C272.935 224.075 262.804 211.333 258.786 215.07V215.07Z",
    fill: "#9461C9",
    stroke: "black",
    strokeWidth: 0.728805
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M255.487 209.59C253.822 211.267 255.453 214.403 256.978 215.536C258.688 217.086 268.29 227.216 275.065 218.693C269.637 218.594 259.506 205.852 255.487 209.59V209.59Z",
    fill: "#9461C9",
    stroke: "black",
    strokeWidth: 0.728805
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M243.654 204.345C247.087 201.792 253.392 201.045 258.304 203.546C262.395 205.551 269.214 213.73 274.34 215.664C270.732 216.308 268.537 215.764 266.231 214.656C261.678 217.953 260.055 218.448 255.415 219.096C248.961 220.027 243.604 218.347 241.722 214.981C239.803 211.806 240.63 206.712 243.654 204.345V204.345Z",
    fill: "#9461C9",
    stroke: "black",
    strokeWidth: 0.774594
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M250.904 211.154C252.536 211.183 253.873 210.439 253.89 209.492C253.907 208.545 252.597 207.754 250.965 207.725C249.332 207.695 247.995 208.44 247.978 209.386C247.961 210.333 249.271 211.125 250.904 211.154Z",
    fill: "#D41C30",
    stroke: "black",
    strokeWidth: 0.706008
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M242.792 218.733C244.925 217.939 246.263 216.242 245.781 214.941C245.298 213.641 243.178 213.23 241.046 214.023C238.913 214.817 237.575 216.514 238.057 217.815C238.539 219.115 240.659 219.526 242.792 218.733Z",
    fill: "#FCD116",
    stroke: "black",
    strokeWidth: 0.764099
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M250.768 210.244C251.355 210.254 251.839 209.851 251.848 209.344C251.857 208.836 251.388 208.416 250.801 208.406C250.214 208.395 249.731 208.798 249.722 209.306C249.713 209.814 250.181 210.234 250.768 210.244Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M244.427 211.733C244.699 213.05 243.722 214.829 241.603 215.459C239.444 216.353 237.807 218.379 236.862 221.693C233.581 214.136 235.667 210.939 239.151 210.162C242.149 209.206 243.956 209.327 244.427 211.733Z",
    fill: "#F1C40F",
    stroke: "black",
    strokeWidth: 0.903199
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M241.303 213.076C241.718 213.054 242.035 212.692 242.012 212.267C241.988 211.843 241.633 211.516 241.218 211.538C240.803 211.56 240.486 211.921 240.51 212.346C240.533 212.771 240.888 213.097 241.303 213.076Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/DM.2dd59ceaf71842a1121f407268147719.svg";
export { ForwardRef as ReactComponent };